import { useParams } from "react-router-dom";
import MobileForm from "../../../../components/MobileForm";

export default function SCE() {
  const { version } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  // const fieldsModule = require(`./v${version}/fields.json`);
  // const fields = fieldsModule.default || fieldsModule;
  console.log({ fields })
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);

  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  return (
    <MobileForm
      type="sce"
      version={version}
      width={width}
      height={newHeight}
      useValidation={useValidation}
      background={background}
      fields={fields}
    />
  );
};
